import Workshop from './Workshop';
import { Navigate, Route } from "react-router-dom";
import { usePermissions } from "../../auth/PermissionContext";
import Recruiting from "./Recruiting";

import BenchSales from "./BenchSales";
import HotList from "./HotList";
import Jobs from "./Jobs";
import PrimeVendors from "./PrimeVendors";
import Clients from "./Clients";
import Candidates from "./Candidates";
import Training from "./Training";
import CandidateOnboarding from "./CandidateOnboarding";
import EmployeeStatusReport from "./EmpStatus";
import UserManagement from "./UserManagement";
import MyProfile from "./MyProfile";
import PermissionMatrix from "./PermissionMatrix";
import DocumentReminders from "./DocumentReminders";
import ApplicationPageView from "./ApplicationPageView";
import PrimeVendorView from "./PrimeVendorView";
import EmployeeView from "./EmployeeView";
import CandidateView from "../../forms/CandidateView";
import JobView from "../../forms/JobView";
import AccessCatalog from "./AccessCatalog";
import AttendanceConfigurations from "../../components/AttendanceConfigurations";
import AttendanceManagement from "./AttendanceManagement";
import RecruiterPerformance from "./RecruiterPerformance.";
import W2Forms from "./W2Forms";
import ChatWorkspace from "../../components/Chat/ChatWorkspace";
import NotificationsPage from "../../components/Collaboration/NotificationsPage";
import AdminChat from "../../components/Chat/AdminChat";


const PAGE_COMPONENTS = {
  recruiting: <Recruiting />,
  workshop: <Workshop />,
  "bench-sales": <BenchSales />,
  hotlist: <HotList />,
  jobs: <Jobs />,
  vendors: <PrimeVendors />,
  clients: <Clients />,
  candidates: <Candidates />,
  training: <Training />,
  "candidate-onboarding": <CandidateOnboarding />,
  employees: <EmployeeStatusReport />,
  users: <UserManagement />,
  profile: <MyProfile />,
  attendance: <AttendanceManagement />,
  permissions: <PermissionMatrix />,
  positions: <AccessCatalog type="positions" />,
  resources: <AccessCatalog type="resources" />,
  "document-reminders": <DocumentReminders />,
  "w2-forms": <W2Forms />,
  chat: <ChatWorkspace />,
  "chat-notifications": <NotificationsPage />,
  "chat-admin": <AdminChat />,
};

const DETAIL_COMPONENTS = {
  recruiting: [
    { suffix: "document-check", element: <Navigate to="/ai-tools/document-check" replace/> },
    { suffix: "resume-match", element: <Navigate to="/ai-tools/resume-match" replace/> },
    { suffix: "performance", element: <RecruiterPerformance module="recruiter" /> },
    { suffix: ":applicationId", element: <ApplicationPageView module="recruiter" /> },
  ],
  "bench-sales": [
    { suffix: "performance", element: <RecruiterPerformance /> },
    { suffix: ":applicationId", element: <ApplicationPageView module="bench" /> },
  ],
  vendors: [{ suffix: ":vendorId", element: <PrimeVendorView /> }],
  candidates: [{ suffix: ":candidateId", element: <CandidateView /> }],
  employees: [{ suffix: ":employeeId", element: <EmployeeView /> }],
  profile: [{ suffix: ":employeeId", element: <EmployeeView /> }],
  jobs: [{ suffix: "jobview/:jobId", absolute: true, element: <JobView /> }],
};

const relativePath = (route) => route.replace(/^\/dashboard\/?/, "").replace(/^\/|\/$/g, "");

export default function useDynamicResourceRoutes() {
  const { resources, can, user } = usePermissions();
  const routes = resources
    .filter((resource) => resource.resource_type === "PAGE"
      && resource.permissions?.view
      && resource.route
      && resource.component_key
      && resource.component_key !== "dashboard")
    .flatMap((resource) => {
      const component = PAGE_COMPONENTS[resource.component_key];
      if (!component) return [];
      const path = relativePath(resource.route);
      const routes = [<Route key={resource.id} path={path} element={component} />];
      for (const detail of DETAIL_COMPONENTS[resource.component_key] || []) {
        const detailPath = detail.absolute ? detail.suffix : `${path}/${detail.suffix}`;
        routes.push(<Route key={`${resource.id}-${detailPath}`} path={detailPath} element={detail.element} />);
      }
      return routes;
    });
  if (can("employees","create") || can("payslips","share") || (can("attendance","edit") && (user?.super_admin || Number(user?.position_id)===1))) {
    routes.push(<Route key="attendance-mail-configurations" path="attendance/configurations" element={<main className="attendance-management"><AttendanceConfigurations/></main>}/>);
  }
  return routes;
}
